import { GetMonthlyInvoicePeriodDtoMeter } from '@eneco/dc-be/client';

export const groupMeterByBillingAccount = (meters: GetMonthlyInvoicePeriodDtoMeter[] | null | undefined) => {
  if (!meters) return null;

  return Object.entries(
    meters.reduce((acc: { [key: string]: (typeof curr)[] }, curr: GetMonthlyInvoicePeriodDtoMeter) => {
      const billingAccountNumber = curr.billingAccountNumber;
      if (!billingAccountNumber) return acc;
      if (!acc[billingAccountNumber]) {
        acc[billingAccountNumber] = [];
      }
      acc[billingAccountNumber].push(curr);
      return acc;
    }, {}),
  );
};
